const MAPBOX_STATIC_BASE = 'https://api.mapbox.com/styles/v1/mapbox/satellite-v9/static'
const MAPBOX_SIZE = '1000x1000@2x'

// Module-level session cache: url → { objectUrl, width, height }
// Lives for the lifetime of the page — avoids redundant fetches across components/re-renders.
// Mapbox Cache-Control headers additionally cache at the HTTP layer for subsequent page loads.
const imageCache = new Map()

const PLACEHOLDER_SVG =
  '<svg xmlns="http://www.w3.org/2000/svg" width="2000" height="2000">' +
  '<rect width="2000" height="2000" fill="#1c2533"/>' +
  '<text x="1000" y="1000" text-anchor="middle" dominant-baseline="middle" ' +
  'font-family="sans-serif" font-size="48" fill="#4a5568">Map unavailable</text>' +
  '</svg>'
const PLACEHOLDER_URL = `data:image/svg+xml,${encodeURIComponent(PLACEHOLDER_SVG)}`
const PLACEHOLDER_RESULT = { objectUrl: PLACEHOLDER_URL, width: 2000, height: 2000 }

export const buildMapboxStaticUrl = (lng, lat, zoom) => {
  const token = import.meta.env.VITE_MAPBOX_TOKEN
  return `${MAPBOX_STATIC_BASE}/${lng},${lat},${zoom}/${MAPBOX_SIZE}?access_token=${token}`
}

export const fetchMapboxImage = async (url) => {
  if (imageCache.has(url)) return imageCache.get(url)

  try {
    const res = await fetch(url)
    if (!res.ok) {
      if (res.status === 429) throw new Error('Mapbox rate limit exceeded')
      throw new Error(`Failed to fetch map image: ${res.status}`)
    }

    const blob = await res.blob()
    const objectUrl = URL.createObjectURL(blob)

    const dimensions = await new Promise((resolve) => {
      const img = new Image()
      img.onload = () => resolve({ width: img.width, height: img.height })
      img.onerror = () => resolve({ width: 2000, height: 2000 })
      img.src = objectUrl
    })

    const result = { objectUrl, ...dimensions }
    imageCache.set(url, result)
    return result
  } catch (err) {
    console.warn('[mapbox-static-api] Image fetch failed, using placeholder:', err.message)
    return PLACEHOLDER_RESULT
  }
}
